import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useRef } from 'react';
import { DeviceSource } from '~/constants/common/DeviceSource';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useDeviceType } from '~/context/common/DeviceContext';
import { logInfo } from '~/utilities/loggers';

export default function useTrackServerClientMobileMismatch() {
  const deviceType = useDeviceType();
  // Capture the SSR-derived value before useResizeListener updates DeviceContext
  const serverIsMobileRef = useRef(deviceType.isMobile);
  const trackEvent = useTrackEvent();

  useEffectOnce(
    () => {
      if (deviceType.isMobile === serverIsMobileRef.current) return;

      const context = {
        isMobile: {
          browser: deviceType.isMobile,
          server: serverIsMobileRef.current
        }
      };

      trackEvent('Server vs client isMobile mismatch', context);
      logInfo('Server vs client isMobile mismatch', context);
    },
    [deviceType.isMobile, trackEvent],
    deviceType.source === DeviceSource.Browser
  );
}
